function setupWebViewJavascriptBridge (callback) {
  if (window.WebViewJavascriptBridge) {
    return callback(window.WebViewJavascriptBridge)
  }
  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback)
  }
  window.WVJBCallbacks = [callback]
  let WVJBIframe = document.createElement('iframe')
  WVJBIframe.style.display = 'none'
  WVJBIframe.src = 'https://__bridge_loaded__'
  document.documentElement.appendChild(WVJBIframe)
  setTimeout(() => {
    document.documentElement.removeChild(WVJBIframe)
  }, 0)
}

class NativeBridge {
  constructor () {
    this.isAppleOS = /(Macintosh|iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
  }

  callHandler (name, data, callback) {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler(name, data, callback)
    })
  }

  registerHandler (name, callback) {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.registerHandler(name, function (data, responseCallback) {
        callback(data, responseCallback)
      })
    })
  }

  invoke (method, data) {
    if (data !== undefined) {
      if (this.isAppleOS) {
        // window.webkit.messageHandlers.kdApp.postMessage({method: method, param: data})
        this.callHandler(method, data, (response) => {})
      } else {
        window.kdApp[method](data)
      }
    } else {
      if (this.isAppleOS) {
        // window.webkit.messageHandlers.kdApp.postMessage({method: method})
        this.callHandler(method, data, (response) => {})
      } else {
        window.kdApp[method]()
      }
    }
  }
}

// App原生调用接口
const native = new NativeBridge()

// 通知App传递token
export function noticeAppSetUserToken () {
  native.invoke('onGetUserToken')
}

// 通知App传递设备信息
export function noticeAppSetDeviceData () {
  native.invoke('onGetDeviceData')
}



// WEBPACK FOOTER //
// ./src/api/KdAppNative.js